<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-layout wrap>
      <v-flex xs8 sm3 md2 lg2>
        <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field :value="fromDate" label="From" solo class="ms-sm-1" append-icon="fa-calendar-alt dark--text" v-bind="attrs" v-on="on" @click:clear="fDate = null" dense></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="fDate" @change="selectFromDate"></v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex xs8 sm2 md2 lg2>
        <v-menu v-model="menu2" :close-on-content-click="false" max-width="290">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field :value="toDate" label="To" class="ms-sm-1" solo append-icon="fa-calendar-alt dark--text" v-bind="attrs" v-on="on" @click:clear="tDate = null" dense></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="tDate" @change="selectToDate"></v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex xs8 sm2 md2 lg2 class="mt-1 ml-4 tw-flex tw-item-center">
        <v-btn color="primary" class="light--text" @click="applyDateFilter" :loading="loading">
          Apply Filter
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :mobile-breakpoint="0"
      :headers="headers"
      :items="itemsWithSno"
      :loading="loading"
      class="mt-4 elevation-1 mt-sm-6"
      :item-class="getRowClass"
      :options.sync="options"
      :server-items-length="totalItemsCount"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template v-slot:item.createdAt="{ item }">
        {{ moment(new Date(parseInt(item.createdAt))).format("DD MMMM YYYY hh:mm a") }}
      </template>

      <template v-slot:item.name="{ item }">
        <div class="d-flex flex-column">
          <span class="font-weight-bold">{{ item.user.firstnameEn }} {{ item.user.lastnameEn }}</span>
          <span class="text--secondary text-caption align-self-end" style="font-size: 0.8em;">{{ item.user.phone }}</span>
        </div>
      </template>
      <template v-slot:item.customer="{ item }">
        <div class="d-flex flex-column">
          <span v-if="item.customer.user" class="font-weight-bold">
            <router-link
              v-if="item.user"
              :to="{
                name: 'CustomerDetails',
                params: { customerId: item.customer._id },
                query: { customerId: item.customer._id },
              }"
              class="mx-auto"
            >
              {{ item.customer.user.firstnameEn[0].toUpperCase() + item.customer.user.firstnameEn.substring(1) }}
              <!-- <div class="mx-1" /> -->
              {{ item.customer.user.lastnameEn[0].toUpperCase() + item.customer.user.lastnameEn.substring(1) }}
            </router-link>
          </span>
          <div v-if="item.customer.user" class="d-flex justify-space-between text--secondary text-caption" style="font-size: 0.8em;">
            <span>Id: {{ item.customer.customerId }}</span>
            <span>Ph: {{ item.customer.user.phone }}</span>
          </div>
        </div>
      </template>
      <template v-slot:item.package="{ item }">
        <span v-if="item.package">{{ item.package.titleEn }}</span>
      </template>
      <template v-slot:item.planDays="{ item }">
        <span v-if="item.package">{{ item.package.availableChoices[0].availableNumOfDays }}</span>
      </template>
      <template v-slot:item.price="{ item }">
        <span v-if="item.price">{{ item.price.toFixed(3) }}</span>
      </template>
      <template v-slot:item.phone="{ item }">{{ item.user.phone }}</template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment from "moment";
import { format, parseISO } from "date-fns";
export default {
  components: {},
  created() {
    if (!this.hasRole(this.AdminUserPermissions.REFERRAL_VIEW)) {
      this.$router.push({
        name: "Error404",
      });
    }
    this.getAllReferralTransactions();
  },
  watch: {
    options: {
      handler() {
        this.getAllReferralTransactions();
        this.tableIndex = this.options.page * this.options.itemsPerPage - this.options.itemsPerPage;
      },
    },
    userType: {
      handler() {
        this.tableIndex = 0;
        this.options.itemsPerPage = 25;
        this.options.page = 1;
      },
    },
  },
  methods: {
    selectFromDate() {
      this.menu1 = false;
    },
    selectToDate() {
      this.menu2 = false;
    },
    getAllReferralTransactions() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("@/referral-transactions/api/getAllReferralTransactions.graphql"),
          variables: {
            userRole: this.userType,
            skip: this.variables.skip,
            limit: this.variables.limit,
            fromDate: this.fromDate,
            toDate: this.toDate,
            type: "CREDIT",
          },
        })
        .refetch({})
        .then(data => {
          this.referralTransactions = [];
          this.loading = false;
          if (data.data.getAllReferralTransactions) {
            this.referralTransactions = data.data.getAllReferralTransactions.userReferrals;
            this.totalItemsCount = data.data.getAllReferralTransactions.totalCount;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },

    applyDateFilter() {
      this.options.page = 1;
      this.getAllReferralTransactions();
    },
    clearDateFilter() {
      this.fromDate = null;
      this.toDate = null;
      this.applyDateFilter();
    },
    getRowClass(item) {
      return item.slNo % 2 === 0 ? "row-light" : "row-dark";
    },
  },
  data() {
    return {
      fDate: format(
        parseISO(
          moment()
            .subtract(7, "days")
            .toDate()
            .toISOString()
        ),
        "yyyy-MM-dd"
      ),
      tDate: format(parseISO(new Date().toISOString()), "yyyy-MM-dd"),
      moment,
      referralTransactions: [],
      loading: true,
      totalItemsCount: 25,
      btnloading: true,
      tableIndex: 0,
      menu1: false,
      menu2: false,
      userType: "CUSTOMER",

      headers: [
        { text: "Date", value: "createdAt", width: 120, sortable: false },
        {
          text: "Referrer  By",
          value: "name",
          width: 200,
          sortable: false,
        },
        {
          text: "Referrer  To",
          value: "customer",
          width: 200,
          sortable: false,
        },
        { text: "Amount Credited", value: "credit", width: 120, sortable: false },
        { text: "Package", value: "package", width: 150, sortable: false },
        { text: "No. of Days", value: "planDays", width: 80, sortable: false },
        { text: "Package Price", value: "price", width: 100, sortable: false },
        { text: "Referral Type", value: "referralType", width: 100, sortable: false },
      ],

      options: {
        itemsPerPage: 25,
        page: 1,
      },
      variables: {
        skip: 0,
        limit: 25,
        userRole: null,
      },
    };
  },
  computed: {
    fromDate() {
      return this.fDate ? moment(this.fDate).format("DD/MM/YYYY") : "";
    },
    toDate() {
      return this.tDate ? moment(this.tDate).format("DD/MM/YYYY") : "";
    },
    itemsWithSno() {
      if (this.referralTransactions == null) return [];
      return this.referralTransactions.map((d, index) => ({
        ...d,
        slNo: index + 1,
      }));
    },
  },
};
</script>
<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
